/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Connectivity_History_Availability_HelpInputs */



/**
* | output |
* | --- |
* | "Share of time the equipment was connected, excluding periods without data" |
*
* @param {Connectivity_History_Availability_HelpInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const connectivity_history_availability_help = /** @type {((inputs?: Connectivity_History_Availability_HelpInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Connectivity_History_Availability_HelpInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Share of time the equipment was connected, excluding periods without data")
	return /** @type {LocalizedString} */ ("Part du temps où l'équipement était connecté, hors périodes sans donnée")
});